<template>
  <div id="deviceinfo">
    <div class="top">
      <div class="back" ref="back" @click="back">{{ $t("index.back") }}</div>
    </div>
    <div class="infocontent">
      <a-row :gutter="10">
        <a-col :span="24">
          <div class="card" id="info">
            <div class="card-head">
              <div class="card_title">设备维修统计</div>
              <div></div>
            </div>
            <div class="card-content">
              <div class="sum_number_item">
                <a-spin :spinning="tabLoading" size="large">
                  <div ref="chartBox" style="width: 100%; height: 79vh"></div>
                </a-spin>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script setup>
import { h, ref, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import * as echarts from "echarts";

const { t } = useI18n();
let router = useRouter();
let userId = ref(localStorage.getItem("userId") || "");
console.log("userId:", userId.value);
const tabLoading = ref(false); //echarts图是否加载
let chartBox = ref(null); //故障时间统计
let myEcharts = echarts;

onMounted(() => {
  //获取维修保养次数
  getMaintainNum();
});
const getMaintainNum = () => {
  tabLoading.value = true;
  let params = {
    // UserId: "483b1f92-93f2-4638-afcf-c58fc2cfc2fe",
    UserId: userId.value,
  };
  axios
    .post("api/Maintenance/GetMDetailNumbers", params)
    .then(function (response) {
      if (response.data.code == 200 && response.data.ReturnType == true) {
        let data = response.data.ReturnData;
        let DataArr = [];
        if (data != null && data.length > 0) {
          DataArr = data.map((item) => {
            return {
              name: item.project,
              value: item.number,
            };
          });
        }
        //渲染图表
        renderChart(DataArr);
      } else {
        message.error(response.data.info);
      }
    })
    .catch(function (error) {})
    .finally(() => {
      tabLoading.value = false;
    });
};

//渲染图表
const renderChart = (data) => {
  let option = {
    // title: {
    //   text: "维修保养统计",
    //   textStyle: {
    //     color: "#333",
    //     fontSize: 16,
    //   },
    // },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: data.map((item) => item.name),
      axisLine: {
        lineStyle: {
          color: "#999",
        },
      },
      axisLabel: {
        color: "#333",
        fontSize: 12,
      },
    },
    yAxis: {
      type: "value",
      axisLine: {
        lineStyle: {
          color: "#999",
        },
      },
      axisLabel: {
        color: "#333",
        fontSize: 12,
      },
    },
    series: [
      {
        name: "维修保养次数",
        type: "bar",
        barWidth: "30",
        data: data.map((item) => item.value),
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(0, 137, 255, 1)" },
            { offset: 1, color: "rgba(0, 137, 255, 0)" },
          ]),
        },
      },
    ],
  };
  myEcharts.init(chartBox.value).setOption(option);
};

/**返回主页面 */
function back() {
  router.push(`/index/repair`);
}
</script>
<style scoped>
#deviceinfo {
  width: 100%;
  height: 100%;
  padding: 0px 0px;
  background-color: #f7f9fa;
  position: relative;
}
.top {
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background-color: white;
  color: black;
  font-weight: bold;
  font-size: 18px;
  position: relative;
  color: #fac858;
}
.back {
  height: 100%;
  line-height: 50px;
  color: #5470c6;
  cursor: pointer;
  position: absolute;
  left: 25px;
}
.infocontent {
  width: 100%;
  padding: 25px 10px 25px 25px;
}
.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin-bottom: 15px;
  height: auto;
  overflow: visible;
  transition: all 0.4s;
  font-size: 14px;
  background-color: white;
  width: 100%;
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}
.card-content {
  width: 100%;
  min-height: 50px;
  padding: 15px;
}
.card_title {
  font-weight: bold;
}
</style>
